import React, { useEffect, useState } from 'react'
import Compressor from 'compressorjs';
import AWS from "aws-sdk";
import useImageConfigS3 from '../HelperComponent/useImageConfigS3';

const useProfileChange = (file=null,upKey=null,delKey=null) => {

    const [s3,bucketName] = useImageConfigS3([]);
    const [profileProgress, setProfileProgress] = useState(0);
    const [profileUrl, setProfileUrl] = useState('');
    const [profileKey, setProfileKey] = useState('');

    const [uploadFile, setFile] = useState(null);
    const [deleleprofileKey, setDeleteFile] = useState(null);


    useEffect(() => {
      setFile(file);
      setDeleteFile(delKey);
      setProfileProgress(0);
    }, [file,delKey]);


      const handleDelete = (delFile) => {

          const params = {
      
              Bucket: bucketName,
              Key: delFile,
            };
          s3.deleteObject(params, (err, data) => {
              if (err) {
                console.error(err);
                return;
              }
              console.log(data);
            });
        
      }
      if(deleleprofileKey){
          handleDelete(deleleprofileKey);
          setDeleteFile(null);
          setProfileUrl(null);
      }

    const handleUpload = (file) => {
      fetch(file)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], 'filename.png', { type: blob.type });
        const extension = file.name.split(".").pop();
        const fileName = new Date().getTime()+"."+extension;
        const params = {
          Bucket: process.env.REACT_APP_S3_BUCKET,
          Key: upKey +"/"+fileName,
          Body: file,
        };
  
        s3.upload(params, (err, data) => {
          if (err) {
            console.error(err);
            return;
          }
          setProfileUrl(data.Location);
          setProfileKey(data.key);
        })
        .on("httpUploadprofileProgress", (evt) => {
          const profileProgressPercentage = parseInt(
            (evt.loaded * 100) / evt.total
          );
          setProfileProgress(profileProgressPercentage);
        });
      })
      .catch((error) => console.error(error));
    };

    if(uploadFile){
        handleUpload(uploadFile);
        setFile(null);
    }

    return [profileUrl,profileKey,profileProgress];
}

export default useProfileChange